import { LoadingOutlined } from '@ant-design/icons'
import { Col, Form, Row, Spin, notification } from 'antd'
import { FooterModal, FromDate } from 'components/templates'
import { useModal } from 'hooks'
import { t } from 'i18next'
import { IBooking } from 'pages/patientBooking/interfaces'
import { useEffect, useState } from 'react'
import { useReceiveServices } from 'services'
import styled from 'styled-components'
import { StyledLabelSpan } from 'styles/styledGlobal'
import { getCurrentDateWithStep, getDateAddMinute } from 'utils'

const StyledFooter = styled(FooterModal)`
  padding: 12px 24px;
`
const StyledCol = styled(Col)`
  margin-bottom: 8px;
`

interface IProps {
  booking: IBooking
}

const EditBookingModal = (props: IProps) => {
  const { booking } = props
  const [form] = Form.useForm()
  const modal = useModal()
  const [loading, setLoading] = useState(false)
  const { updateBooking } = useReceiveServices()
  useEffect(() => {
    if (booking) {
      form.setFieldsValue({
        fromTime: {
          date: new Date(booking.from),
          time: new Date(booking.from)
        }
      })
    }
  }, [booking])

  const antIcon = <LoadingOutlined style={{ fontSize: 50 }} spin />

  const timeBooking = getCurrentDateWithStep(30)
  timeBooking.setTime(timeBooking.getTime())

  const handleSubmit = async () => {
    const { fromTime } = form.getFieldsValue()
    setLoading(true)
    try {
      const res = await updateBooking(booking.booking_id, {
        from_time: new Date(fromTime?.date).getTime(),
        to_time: getDateAddMinute(new Date(fromTime?.date), 30)?.getTime()
      })
      if (res._successfully) {
        notification.success({ message: t('update-time-booking-success') })
      }
      modal.close(res)
    } catch (error) {
    } finally {
      setLoading(false)
    }
  }

  return (
    <Spin spinning={loading} indicator={antIcon}>
      <Form style={{ padding: '12px 24px' }} form={form}>
        <Row gutter={16}>
          <StyledCol span={24}>
            {`${t('fullname')}: `}
            <StyledLabelSpan> {booking?.patient.full_name}</StyledLabelSpan>
          </StyledCol>
          <StyledCol span={24}>
            {`${t('phone-number')}: `}
            {booking?.patient.phone_number}
          </StyledCol>
          <Col span={24}>
            <Form.Item
              name="fromTime"
              rules={[
                {
                  required: true,
                  message: t('please-enter-info') || ''
                }
              ]}>
              <FromDate minDate={new Date()} minTime={timeBooking} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <StyledFooter cancelLabel={t('close')} onSubmit={handleSubmit} />
    </Spin>
  )
}

export default EditBookingModal
